import { IBriefResource } from "../../briefs";
import { ICategoryResource } from "../../categories";
import { EntityTypes } from "../../EntityTypes";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, mapRelationalValueAsIRI, RelationalValue } from "../../utils/filters";
import { ITag, ITagResource } from "../types";

export type ITagUpdateMutationParameters = {
    tag: RelationalValue<ITagResource>;
    title?: string;
    categories?: RelationalValue<ICategoryResource>[];
    briefs?: RelationalValue<IBriefResource>[];
};

export type ITagUpdateMutationResult = ITag;

export const tagUpdateMutation: IApiMutationFunction<ITagUpdateMutationParameters> = ({
    tag,
    title,
    categories,
    briefs,
}) => {
    return {
        method: "PUT",
        url: `/tags/${mapRelationalValue(tag)}`,
        data: {
            ...(title === undefined ? {} : { title }),
            categories: categories?.map(category => mapRelationalValueAsIRI(EntityTypes.CATEGORY, category)),
            briefs: briefs?.map(brief => mapRelationalValueAsIRI(EntityTypes.BRIEF, brief)),
        },
    };
};

export const useTagUpdateMutation = createApiMutationHook<ITagUpdateMutationParameters, ITagUpdateMutationResult>(
    tagUpdateMutation,
);
